<template>
  <div class="container">
    <div class="inner-component">
      <slot />
    </div>
    <div class="error-container" v-if="description">
      <div v-if="showErrorIcon">
        <img src="@/assets/img/1x/alert.svg" alt="Ícono error" />
      </div>
      <div>
        <p class="description" v-safe-html="description" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloatingTipError",
  props: {
    description: String,
    errorCode: String,
    showErrorIcon: Boolean,
    double: Boolean
  }
};
</script>

<style scoped>
.inner-component >>> div {
  margin-bottom: 8px;
}
p.description {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: #121212;
}

div.error-container {
  display: flex;
  padding: 0 16px 20px 16px;
  margin-bottom: 20px;
  background: #f7fcfc;
}

div.description-container div {
  display: inline-block;
  vertical-align: top;
}

div.error-container div > img {
  margin-top: 50%;
  margin-right: 12px;
  width: 22px;
}

div.description-container div > span {
  display: block;
}

@media screen and (min-width: 600px) {
  .container {
    position: relative;
  }
}
</style>
